var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ml-2 mt-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41065 1.83848L0.808079 7.89763C0.774862 7.9282 0.750876 7.9668 0.739455 8.00829L0.00762279 10.7037C-0.0142684 10.7849 0.0117155 10.8712 0.0762469 10.9304C0.125074 10.9752 0.191604 11 0.259657 11C0.280501 11 0.301821 10.9976 0.32257 10.9928L3.25999 10.3212C3.30577 10.3107 3.34736 10.2888 3.38058 10.2583L9.98373 4.1996L7.41065 1.83848Z",
    fill: "#1D4469"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6195 1.01234L10.8845 0.337904C10.3933 -0.112853 9.53715 -0.112416 9.0465 0.337904L8.1462 1.16404L10.7192 3.52508L11.6195 2.69894C11.8648 2.47387 12 2.1743 12 1.85568C12 1.53707 11.8648 1.2375 11.6195 1.01234Z",
    fill: "#1D4469"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencilIcon.0dbf32e25e74d0aea4618e498b1975e8.svg";
export { ForwardRef as ReactComponent };